<template>
    <component
        :is="tag"
        @dragenter="emitDragEvent(events.dragenter, $event)"
        @dragleave="emitDragEvent(events.dragleave, $event)"
        @dragover.prevent="emitDragEvent(events.dragover, $event)"
        @drop.prevent="emitDragEvent(events.drop, $event)"
    >
        <slot :transfer-data="scopedData"></slot>
    </component>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop } from '@/helpers/Decorators';
import { events } from './constants';
import transferDataStore from './transferDataStore';

const insideElements = new Set();

@Options({
    name: 'vue-drop',
    emits: [
        events.dragenter,
        events.dragleave,
        events.dragover,
        events.drop
    ]
})
export default class Drop extends Vue
{
    @Prop({ default: 'div' })
    public tag: string;

    public transferData: any = undefined;
    public isDraggingOver: boolean = false;

    public get events(): Record<string, string>
    {
        return events;
    }

    public get scopedData(): boolean
    {
        return this.isDraggingOver && this.transferData;
    }

    public emitDragEvent(name: string, nativeEvent: any): void
    {
        if (transferDataStore.data)
        {
            this.transferData = transferDataStore.data;
            this.$emit(name, this.transferData, nativeEvent);

            // After emitting the event, we need to determine if we're still
            // dragging inside this Drop. We keep a Set of all elements that we've
            // dragged into, then clear the data if that set is empty.

            // Add to the set on dragenter.
            if (name === events.dragenter)
            {
                if (insideElements.size || nativeEvent.target === this.$el)
                {
                    insideElements.add(nativeEvent.target);
                }
            }

            // Remove from the set on dragleave.
            if (name === events.dragleave)
            {
                insideElements.delete(nativeEvent.target);
            }

            // A drop resets everything.
            if (name === events.drop)
            {
                insideElements.clear();
            }

            // Finally, since Vue can't react to Set changes, set a flag indicating drag status.
            this.isDraggingOver = Boolean(insideElements.size);
        }
    }
}
</script>
